<template>
  <BToast
    :model-value="errorsStore.showError"
    :variant="(errorsStore.variant as any)"
    @update:model-value="errorsStore.dismissError()"
  >
    {{ errorsStore.message }}
  </BToast>
</template>

<script setup lang="ts">
import { BToast } from 'bootstrap-vue-next'
import { useErrorsStore } from '@/stores/useErrorsStore'
const errorsStore = useErrorsStore()
</script>
